import * as QueryString from 'query-string';
import TabNavigation from '@ey/motif-react-wrapper/TabNavigation';
import TabControl from '@ey/motif-react-wrapper/TabControl';
import Dropdown from '@ey/motif-react-wrapper/Dropdown';
import DropdownItem from '@ey/motif-react-wrapper/DropdownItem';
import Button from '@ey/motif-react-wrapper/Button';
import Icon from '@ey/motif-react-wrapper/Icon';
import React, {useEffect, useState} from 'react';
import {
	displayGroupings,
	EngagementSortBy,
	engagementV2DefaultSkip,
	engagementV2DefaultTop,
	engagementV2PageSizeOptions,
	labels,
	pagerOptions,
	permissionGroups,
	searchTypes,
	settingsPreferences,
	standardStrings,
	tabTypes,
	urls
} from '../../util/uiconstants';
import {
	getMyWorkspaces,
	getReviewEngagements
} from '../../actions/workspacesactions';
import {
	getUserPermissions,
	setUserSettings,
	updateGroupPrefUserSettings,
	updatePagePrefUserSettings
} from '../../actions/usersettingsaction';
import {
	searchEngagementState,
	setCurrentActiveTabInMyEngSection,
	setCurrentGroupingTypeInMyEngSection
} from '../../actions/dashboardactions';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory, useLocation} from 'react-router-dom';

import ClientList from '../Clients/clientlist';
import DashboardStyles from './dashboardStyleComp';
import EngagementGrouping from './engagemengrouping';
import EngagementList from './engagementlist';
import LoadingIndicator from '../Common/LoadingIndicator/LoadingIndicator';
import Pagination from '@ey/pager';
import PortfolioView from './PortfolioView/portfolioview';
import MotifSearch from '@ey/motif-react-wrapper/Search';
import Toast from '../Common/Toast/Toast';
import _ from 'lodash';
import {clearToastError} from '../../actions/engagementerroraction';
import {contentIcAddCircle24px} from '@ey-xd/motif-react/assets/icons';
import env from '../../util/env';
import {getFavoriteEngagements} from '../../actions/favoriteengagementsaction';
import {getFavoriteWorkspaces} from '../../actions/favoriteworkspacesaction';
import {getMyEngagements} from '../../actions/engagementsaction';
import {getReviewWorkspaces} from '../../actions/reviewworkspaceaction';
import styled from 'styled-components';
import {successMessageDisplayDuration} from '../../util/uiconstants';
import UAParser from 'ua-parser-js';
import {deviceIcDevices24px} from '@ey/motif-react-wrapper/assets/icons/index';
import {IconoirDataTransferBoth, IconoirCheck} from '@ey-xd/motif-icon';
import {adobeAnalytics} from '@ey/voltron-analytics';
import {
	clickActionArgs,
	pageViewArgs
} from '../Common/Adobe Analytics/actionHelpers.js';
import {
	eventTypes,
	controlTypes,
	clickActionNames,
	locationInPages,
	pageNames,
	siteSections
} from '../Common/Adobe Analytics/constants.js';
import MotifSelect from '@ey/motif-react-wrapper/Select';
import MotifFormField from '@ey/motif-react-wrapper/FormField';
import MotifOption from '@ey/motif-react-wrapper/Option';
import MotifLabel from '@ey/motif-react-wrapper/Label';

/* 
 refreshDashboard  :This is a prop passed to child component if we want to refresh parent.
*/
const Dashboard = (props) => {
	const {location, viewDisplayName} = props;

	const dispatch = useDispatch();
	const history = useHistory();
	const search = useLocation().search.toLowerCase();
	const trackEvent = adobeAnalytics.useAdobeAnalyticsTrack();
	const params = QueryString.parse(location.search);
	const hasGroupBy = params.groupby;
	const defaultTab = tabTypes.AllEngagementsTab;

	const currentTab = useSelector((store) => store.dashboard.activeTab);
	const engagementError = useSelector((store) => store.engagementError);
	const favoriteEngagements = useSelector((store) => store.favoriteEngagements);
	const favoriteWorkspaces = useSelector((store) => store.favoriteWorkspaces);
	const myEngagements = useSelector((store) => store.myEngagements);
	const myWorkspaces = useSelector((store) => store.myWorkspaces);
	const preferredLandingPageView = useSelector(
		(store) => store.userSettings?.data?.preferredlandingpageview
	);
	const preferredNumberOfEngagements = useSelector(
		(store) => store.userSettings?.data?.preferrednumberofengagements
	);
	const reviewEngagements = useSelector((store) => store.reviewEngagements);
	const reviewWorkspaces = useSelector((store) => store.reviewWorkspaces);
	const searchText = useSelector((store) => store.searchEngagementState);
	const successfulToastMessage = useSelector(
		(store) => store.successfulToastMessage
	);
	const userPermissions = useSelector((store) => store.userPermissions);
	const userSettings = useSelector((store) => store.userSettings);

	const defaultGroupingUserSetting =
		preferredLandingPageView === settingsPreferences.WorkspaceList
			? displayGroupings.MODULE
			: displayGroupings.LIST;

	const [clients, setClients] = useState([]);
	const [currentTabState, setCurrentTabState] = useState(defaultTab);
	const [engagementList, setEngagementList] = useState([]);
	const [groupBy, setGroupBy] = useState(
		_.isEmpty(location.search)
			? preferredLandingPageView === settingsPreferences.WorkspaceList
				? displayGroupings.MODULE
				: displayGroupings.LIST
			: displayGroupings.MODULE
	);
	const [isAdobeInitialized, setIsAdobeInitialized] = useState(false);
	const [isFirstRenderFinish, setIsFirstRenderFinish] = useState(false);
	const [isLoading, setIsLoading] = useState(true);
	const [isMobile, setIsMobile] = useState(false);
	const [isReviewEngagementAvailable, setIsReviewEngagementAvailable] =
		useState(false);
	const [isSearching, setIsSearching] = useState(false);
	const [selectedEngagementSortBy, setSelectedEngagementSortBy] = useState(
		userSettings?.data?.sortorder || EngagementSortBy.lastAccessDate
	);
	const [showDropdownState, setShowDropdownState] = useState(false);
	const [skip, setSkip] = useState(
		(myEngagements &&
			myEngagements.pagermetadata &&
			myEngagements.pagermetadata.currentpagenumber) ||
			1
	);
	const [successMessage, setSuccessMessage] = useState('');
	const [top, setTop] = useState(
		(myEngagements &&
			myEngagements.pagermetadata &&
			preferredNumberOfEngagements) ||
			preferredNumberOfEngagements ||
			10
	);
	const [totalPages, setTotalPages] = useState(0);
	const [totalRecordCount, setTotalRecordCount] = useState(0);
	const [userInfo, setUserInfo] = useState({
		isThirdPartyUser: false,
		isThirdPartyUserWithNoRecord: false
	});

	const svgHoverText = {
		first: labels.firstpage,
		previous: labels.prevpage,
		next: labels.nextpage,
		last: labels.lastpage
	};

	const archiveRetryShortcutKey = env.getArchiveRetryShortcutKey();
	const perm = userPermissions.userpermissions;
	const successMessageDuration = successMessageDisplayDuration;

	const topEngagementv2 = engagementV2PageSizeOptions.includes(
		parseInt(new URLSearchParams(search).get('pagesize'))
	)
		? parseInt(new URLSearchParams(search).get('pagesize'))
		: engagementV2DefaultTop;

	const skipEngagementv2 =
		!new URLSearchParams(search).has('pagenumber') ||
		parseInt(new URLSearchParams(search).get('pagenumber')) < 1
			? engagementV2DefaultSkip
			: parseInt(new URLSearchParams(search).get('pagenumber'));

	const pathAndTabs = [
		{
			path: '/engagements',
			tab: tabTypes.AllEngagementsTab
		},
		{
			path: '/favorites',
			tab: tabTypes.FavoritesTab
		},
		{
			path: '/reviewengagements',
			tab: tabTypes.ReviewengagementsTab
		},
		{
			path: '/',
			tab: tabTypes.engagementsv1Tab
		}
	];

	const isTabEngV2 = [
		tabTypes.portfolioViewTab,
		tabTypes.engagementsv2Filter,
		tabTypes.favoritesv2Filter,
		tabTypes.reviewengagementsv2Filter
	].includes(currentTabState);

	const engagementSortByOptions = [
		{
			id: EngagementSortBy.lastAccessDate,
			value: labels.engagementSortByOptions.lastAccessDate
		},
		{
			id: EngagementSortBy.engagementDescription,
			value: labels.engagementSortByOptions.engagementName
		}
	];

	useEffect(() => {
		checkIsUserGlobalReviewPortalMember();
		const initialGroupingType = _.isEmpty(location.search)
			? preferredLandingPageView === settingsPreferences.WorkspaceList
				? displayGroupings.MODULE
				: displayGroupings.LIST
			: displayGroupings.MODULE;
		dispatch(setCurrentGroupingTypeInMyEngSection(initialGroupingType));
		onTabChanged(getTab(location.pathname));
		setIsFirstRenderFinish(true);
	}, []);

	useEffect(() => {
		let parser = new UAParser();
		let result = parser.getResult();
		setIsMobile(['mobile', 'tablet'].includes(result.device.type));
	}, []);

	useEffect(() => {
		if (successMessage) {
			var timer = setTimeout(() => {
				setSuccessMessage('');
			}, successMessageDuration);

			return () => clearTimeout(timer);
		}
	}, [successMessage]);

	useEffect(() => {
		if (
			userSettings?.data?.isguestuser !== null &&
			userSettings?.data?.isguestuser !== undefined
		) {
			setUserInfo({
				isThirdPartyUser: userSettings.data.isguestuser,
				isThirdPartyUserWithNoRecord: false
			});
		} else {
			if (
				userSettings.isError &&
				JSON.parse(userSettings?.request?.response).ErrorMessage !== '938'
			) {
				setUserInfo({
					isThirdPartyUser: undefined,
					isThirdPartyUserWithNoRecord: undefined
				});
			} else {
				setUserInfo({
					isThirdPartyUser: true,
					isThirdPartyUserWithNoRecord: true
				});
			}
		}
	}, [userSettings]);

	useEffect(() => {
		const fetchData = async () => {
			if (
				!location.pathname.includes('/engagementsv2') &&
				isFirstRenderFinish
			) {
				setGroupPreferences();
				await loadPagedDataAsync();
			}
		};
		fetchData();

		if (isFirstRenderFinish && !isAdobeInitialized) {
			trackTabChange(getTab(location.pathname));
			setIsAdobeInitialized(true);
		}
	}, [
		skip,
		top,
		preferredLandingPageView,
		isFirstRenderFinish,
		currentTab,
		selectedEngagementSortBy
	]);

	useEffect(() => {
		checkIsReviewEngagementAvailable();
	}, [userPermissions]);

	useEffect(() => {
		// Determine if we're in list view or module view
		const preferredPageView =
			preferredLandingPageView ?? settingsPreferences.EngagementList;
		const isListView = preferredPageView === settingsPreferences.EngagementList;
		const viewMode = isListView
			? displayGroupings.LIST
			: displayGroupings.MODULE;

		// Create a mapping of tab types to their corresponding data sources
		const dataSources = {
			list: {
				[tabTypes.FavoritesTab]: favoriteEngagements,
				[tabTypes.ReviewengagementsTab]: reviewEngagements,
				default: myEngagements
			},
			module: {
				[tabTypes.FavoritesTab]: favoriteWorkspaces,
				[tabTypes.ReviewengagementsTab]: reviewWorkspaces,
				default: myWorkspaces
			}
		};

		// Get the appropriate data source based on current tab and view mode
		const dataSource =
			dataSources[viewMode][currentTab] || dataSources[viewMode].default;

		if (isListView) {
			// Handle list view (engagements)
			setSkip(dataSource?.pagermetadata?.currentpagenumber || 1);
			setEngagementList(dataSource);
		} else {
			// Handle module view (workspaces)
			setClients(dataSource?.collections?.clients || []);
		}

		// Set pagination metadata (common for both views)
		setTotalPages(dataSource?.pagermetadata?.totalpages || 0);
		setTotalRecordCount(dataSource?.pagermetadata?.totalnumberofrecords || 0);

		// Update pagination state and finish loading
		setPaginationState(viewMode, currentTab);
		setIsLoading(false);
	}, [
		myEngagements,
		favoriteEngagements,
		reviewEngagements,
		myWorkspaces,
		favoriteWorkspaces,
		reviewWorkspaces
	]);

	useEffect(() => {
		if (params.reportreleasedate) {
			history.push({
				pathname: '/editengagement',
				search:
					'?workspaceid=' +
					params.workspaceid +
					'&engagementid=' +
					params.engagementid
			});
		}
	}, [params]);

	const getTab = (pathName) => {
		const route = pathAndTabs.find((x) => x.path === pathName);
		return route ? route.tab : tabTypes.engagementsv1Tab;
	};

	const checkIsUserGlobalReviewPortalMember = () => {
		if (perm) {
			return;
		}
		let userPermissionsUrl =
			env.getURL('serviceUrl') + '/' + urls.USERS_PERMISSION_URL;
		dispatch(getUserPermissions(userPermissionsUrl));
		setIsLoading(false);
	};

	const trackTabChange = (tabKey) => {
		// Adobe Analytics Page Tracking
		switch (tabKey) {
			case 'myengtabs':
				trackEvent(
					eventTypes.pageView,
					pageViewArgs(
						pageNames.engagements,
						siteSections.engagementsHome,
						true
					)
				);
				break;
			case 'myFavEng':
				trackEvent(
					eventTypes.pageView,
					pageViewArgs(pageNames.favorites, siteSections.engagementsHome, true)
				);
				break;
			case tabTypes.ReviewengagementsTab:
				// Adobe Analytics Page Tracking
				trackEvent(
					eventTypes.pageView,
					pageViewArgs(pageNames.review, siteSections.engagementsHome, true)
				);
				break;
			default:
				if (
					userSettings &&
					userSettings.data &&
					userSettings.data.preferredlandingpagefilter ===
						settingsPreferences.FavoriteEngagements
				) {
					// Adobe Analytics Page Tracking
					trackEvent(
						eventTypes.pageView,
						pageViewArgs(
							pageNames.favorites,
							siteSections.engagementsHome,
							true
						)
					);
				} else {
					// Adobe Analytics Page Tracking
					trackEvent(
						eventTypes.pageView,
						pageViewArgs(
							pageNames.engagements,
							siteSections.engagementsHome,
							true
						)
					);
				}
		}
	};

	const onTabChanged = (tabKey) => {
		const param = groupBy == displayGroupings.MODULE ? '?groupby=clients' : '';
		let redirectTab = '';
		switch (tabKey) {
			case 'myengtabs':
				history.push('/engagements' + param);
				break;
			case 'myFavEng':
				history.push('/favorites' + param);
				break;
			case tabTypes.ReviewengagementsTab:
				history.push('/reviewengagements' + param);
				break;
			default:
				if (
					userSettings &&
					userSettings.data &&
					userSettings.data.preferredlandingpagefilter ===
						settingsPreferences.FavoriteEngagements
				) {
					history.push('/favorites' + param);
					redirectTab = tabTypes.FavoritesTab;
				} else {
					history.push('/engagements' + param);
					redirectTab = tabTypes.AllEngagementsTab;
				}
		}
		setCurrentTabState(redirectTab.length > 0 ? redirectTab : tabKey);
		setSkip(1);
		dispatch(
			setCurrentActiveTabInMyEngSection(
				redirectTab.length > 0 ? redirectTab : tabKey
			)
		);
		if (isAdobeInitialized) trackTabChange(tabKey);
	};

	const loadPagedDataAsync = async (isSearchTextEmpty, resetPage) => {
		await loadPagedData(isSearchTextEmpty, resetPage);
	};

	const checkIsReviewEngagementAvailable = () => {
		// Check three different conditions that can make review engagements available
		const isEyPortalUser = isGlobalPortalUser() && isEyUser();
		const isValidThirdPartyUser =
			userInfo.isThirdPartyUser != null &&
			userInfo.isThirdPartyUserWithNoRecord != null &&
			(userInfo.isThirdPartyUser || userInfo.isThirdPartyUserWithNoRecord);
		const isGuestUser = userSettings?.data?.isguestuser === true;

		// If any of these conditions are true, review engagements are available
		setIsReviewEngagementAvailable(
			isEyPortalUser || isValidThirdPartyUser || isGuestUser
		);
	};

	const setGroupPreferences = async () => {
		let groupPreference = defaultGroupingUserSetting;

		if (
			((location.pathname === '/' ||
				location.pathname === '/reviewengagements') &&
				defaultGroupingUserSetting === displayGroupings.MODULE) ||
			hasGroupBy
		) {
			groupPreference = displayGroupings.MODULE;
			await dispatch(
				updateGroupPrefUserSettings(settingsPreferences.WorkspaceList)
			);
		} else {
			groupPreference = displayGroupings.LIST;
			await dispatch(
				updateGroupPrefUserSettings(settingsPreferences.EngagementList)
			);
		}

		return groupPreference;
	};

	const checkRejectInvitationSuccessMessage = () => {
		if (
			successfulToastMessage?.message ===
			labels.independenceOnlyRejectInvite.succesfulRejection
		) {
			setSuccessMessage(successfulToastMessage?.message);
		}
	};

	const isEyUser = () => {
		// Case 1: We have valid user settings with a defined isguestuser property
		if (userSettings?.data?.isguestuser != null) {
			return !userSettings.data.isguestuser;
		}

		// Case 2: Error response with code other than '938'
		if (
			userSettings?.isError &&
			JSON.parse(userSettings?.request?.response || '{}').ErrorMessage !== '938'
		) {
			return undefined;
		}

		// Case 3: Default case - treat as non-EY user
		return false;
	};

	const isGlobalPortalUser = () => {
		// Return false if no user permissions exist
		if (!userPermissions?.userpermissions) {
			return false;
		}

		// Check if user has the Global ReviewPortal permission
		// Note: The comment "Global\ReviewPortal - id=14" provides context about the permission
		return userPermissions.userpermissions.some(
			(permission) =>
				permission.groupname === permissionGroups.Global_ReviewPortal
		);
	};

	const loadPagedData = async (isSearchTextEmpty, resetPage) => {
		setIsLoading(true);

		// Prepare parameters for API calls
		const searchKey = encodeURIComponent(
			isSearchTextEmpty ? '' : searchText.searchText
		);
		const page = resetPage ? 1 : skip;
		const preferredPageView =
			preferredLandingPageView ?? settingsPreferences.EngagementList;

		// Determine if we're in list or module view - use this calculation only once
		const isListView = preferredPageView === settingsPreferences.EngagementList;
		const displaytypeid = isListView ? 1 : 2;

		// Determine URL phase based on tab
		const phase =
			currentTab === tabTypes.ReviewengagementsTab
				? 'MyCSRWorkspaces'
				: 'MyNavigation';

		// Build base URL
		const baseUrl = env.getURL('serviceUrl');
		const mainUrl = `${baseUrl}/home.json?phase=${phase}&Top=${top}&Skip=${page}`;
		const apiBaseUrl = mainUrl.split('/api/v1')[0];

		// Determine search type based on current tab and view
		let searchTypeId;
		switch (currentTab) {
			case tabTypes.FavoritesTab:
				searchTypeId = searchTypes.MY_FAVORITES;
				break;
			case tabTypes.ReviewengagementsTab:
				searchTypeId = searchTypes.REVIEW_ENGAGEMENTS;
				break;
			default:
				searchTypeId = isListView
					? searchTypes.EXCLUDE_WORKSPACE
					: searchTypes.ALL;
				break;
		}

		// Build the filters part of the URL
		const filters = [
			`searchtypeid eq ${searchTypeId}`,
			`displaytypeid eq ${displaytypeid}`
		];

		// Only append the sort parameter if we're not in module grouping view
		if (groupBy !== displayGroupings.MODULE) {
			filters.push(`sortBy eq ${selectedEngagementSortBy}`);
		}

		// Combine into the final URL
		const searchURLPart = `&filters=${filters.join(
			','
		)}&SearchExpression=${searchKey}`;
		const fullUrl = mainUrl + searchURLPart;

		// Define action mappings to simplify dispatch logic
		const actions = {
			list: {
				[tabTypes.FavoritesTab]: () =>
					dispatch(
						getFavoriteEngagements(
							fullUrl,
							apiBaseUrl,
							selectedEngagementSortBy
						)
					),
				[tabTypes.ReviewengagementsTab]: () =>
					dispatch(
						getReviewEngagements(fullUrl, apiBaseUrl, selectedEngagementSortBy)
					),
				default: () =>
					dispatch(
						getMyEngagements(fullUrl, apiBaseUrl, selectedEngagementSortBy)
					)
			},
			module: {
				[tabTypes.FavoritesTab]: () =>
					dispatch(getFavoriteWorkspaces(fullUrl, apiBaseUrl)),
				[tabTypes.ReviewengagementsTab]: () =>
					dispatch(getReviewWorkspaces(fullUrl, apiBaseUrl)),
				default: () => dispatch(getMyWorkspaces(fullUrl, apiBaseUrl))
			}
		};

		// Execute the appropriate action based on view and tab type
		const viewType = isListView
			? displayGroupings.LIST
			: displayGroupings.MODULE;
		const action = actions[viewType][currentTab] || actions[viewType].default;
		await action();

		checkRejectInvitationSuccessMessage();
	};

	const setPaginationState = (selectedGroupBy, selectedCurrentTab) => {
		// Create a mapping of tab types to their corresponding data sources
		const dataSources = {
			[tabTypes.FavoritesTab]: {
				engagements: favoriteEngagements,
				workspaces: favoriteWorkspaces
			},
			[tabTypes.ReviewengagementsTab]: {
				engagements: reviewEngagements,
				workspaces: reviewWorkspaces
			},
			default: {
				engagements: myEngagements,
				workspaces: myWorkspaces
			}
		};

		// Get the appropriate data source based on current tab
		const dataSource = dataSources[selectedCurrentTab] || dataSources.default;

		// Default page sizes
		const DEFAULT_LIST_SIZE = 10;
		const DEFAULT_MODULE_SIZE = 5;

		// Determine the appropriate page size
		const isListView = selectedGroupBy === displayGroupings.LIST;
		const currentData = isListView
			? dataSource.engagements
			: dataSource.workspaces;
		const defaultSize = isListView ? DEFAULT_LIST_SIZE : DEFAULT_MODULE_SIZE;

		// Set the pagination size with proper fallbacks
		setTop(
			currentData?.pagermetadata?.preferredNumberOfEngagements ||
				preferredNumberOfEngagements ||
				defaultSize
		);

		setGroupBy(selectedGroupBy);
	};

	const getMenuItems = () => {
		return [getCreateEngagementDetails(), getImportengagementDetails()];
	};

	const getCreateEngagementDetails = () => {
		return {
			linkTo: {
				pathname: '/createengagement'
			},
			label: labels.createengagementheader
		};
	};

	const getImportengagementDetails = () => {
		return {
			linkTo: {
				pathname: '/import'
			},
			label: labels.importengagementheader
		};
	};

	const activeClassHandler = (index) => {
		return getTab(location.pathname) === index ? 'motif-active' : '';
	};

	const handleEngagementOptionsChange = (value) => {
		setShowDropdown(false);
		history.push(value.linkTo.pathname);
		// Adobe Analytics Click Tracking
		trackEvent(
			eventTypes.clickAction,
			clickActionArgs(
				value.linkTo.pathname
					.toLowerCase()
					.includes(
						clickActionNames.createEngagement.replace(' ', '').toLowerCase()
					)
					? clickActionNames.createEngagement
					: clickActionNames.importTemplate,
				controlTypes.dropdown,
				locationInPages.menu,
				window.location.origin + value.linkTo.pathname
			)
		);
	};

	const onPagerDropdownChange = (e) => {
		setTop(parseInt(e.value));
		setSkip(1);
		dispatch(
			updatePagePrefUserSettings({
				engagements: parseInt(e.value)
			})
		);

		trackPaginationClickAction(
			`${clickActionNames.paginationSize} ${e.value}`,
			controlTypes.dropdown
		);
	};

	const onPagerInputChange = (e) => {
		e = parseInt(e.target.value);
		if (!(e > 0)) {
			setSkip(1);
		} else {
			if (e > totalPages) {
				e = totalPages;
			}
			setSkip(e);
		}
	};

	const onFirstPageClicked = () => {
		setSkip(1);
		trackPaginationClickAction(clickActionNames.gotoFirstPage);
	};

	const onPrevPageClicked = () => {
		setSkip((prev) => prev - 1);
		trackPaginationClickAction(clickActionNames.gotoPreviousPage);
	};

	const onNextPageClicked = () => {
		setSkip((prev) => prev + 1);
		trackPaginationClickAction(clickActionNames.gotoNextPage);
	};

	const onLastPageClicked = () => {
		setSkip(totalPages);
		trackPaginationClickAction(clickActionNames.gotoLastPage);
	};

	const trackPaginationClickAction = (
		name,
		controlType = controlTypes.icon
	) => {
		// Adobe Analytics Click Tracking
		trackEvent(
			eventTypes.clickAction,
			clickActionArgs(name, controlType, locationInPages.engagementsPagination)
		);
	};

	const onClearSearchText = () => {
		setSkip(1);
		dispatch(searchEngagementState(standardStrings.EMPTY));
		loadPagedDataAsync(true, true);
	};

	const isPortfolioActive = () => {
		if (!env.getPortfolioCfg()) {
			// Adobe Analytics Page Tracking
			trackEvent(
				eventTypes.pageView,
				pageViewArgs(pageNames.engagements, siteSections.engagementsHome, true)
			);
			history.push('/engagements');
			return false;
		} else {
			return true;
		}
	};

	const setClickOutside = () => {
		setShowDropdown(false);
	};

	const handleToggle = () => {
		setShowDropdown(true);
	};

	const handleAdobe = () => {
		// Adobe Analytics Click Tracking
		trackEvent(
			eventTypes.clickAction,
			clickActionArgs(
				clickActionNames.addEngagement,
				controlTypes.button,
				locationInPages.menu
			)
		);
	};

	const setShowDropdown = (value) => {
		setShowDropdownState(value);
	};

	// Handler for user-initiated sort order changes - updates state and persists to API
	const onEngagementSortByChangeHandler = async (e) => {
		// Update the local state first
		setSelectedEngagementSortBy(e);

		// Only update user preferences if we have user settings data
		if (userSettings && userSettings.data) {
			setIsLoading(true);
			const userSettingsUrl = env.getURL('serviceUrl') + '/' + urls.USERS_URL;

			// Create a model that keeps all existing settings and adds/updates the sortOrder property
			const updatedModel = {
				collections: {
					userscollection: [
						{
							data: {
								...userSettings.data,
								sortorder: e.toString() // Use the new value directly
							}
						}
					]
				}
			};

			try {
				await dispatch(
					setUserSettings(userSettingsUrl + '/' + userSettings.id, updatedModel)
				);
			} finally {
				setIsLoading(false);
			}
		}
	};

	const handleOnSubmit = () => {
		// Set the searching state based on whether there is search text
		setIsSearching(searchText?.searchText?.length > 0);
		setSkip(1);
		loadPagedDataAsync(false, true);
	};

	return (
		<DashboardStyles className="customScrollbar view-wrapper">
			{successMessage && (
				<Toast
					variant="success"
					duration={successMessageDuration}
					onClose={() => setSuccessMessage(undefined)}
				>
					{successMessage}
				</Toast>
			)}
			{engagementError?.message && (
				<StyledNotificationToast>
					<Toast variant="error" onClose={() => dispatch(clearToastError())}>
						{engagementError.message}
					</Toast>
				</StyledNotificationToast>
			)}
			<section className="menu-nav">
				<StyledTabBar>
					<TabNavigation variant="alt" className="view-switcher">
						{userInfo.isThirdPartyUser !== undefined &&
						userInfo.isThirdPartyUserWithNoRecord !== undefined &&
						!userInfo.isThirdPartyUser &&
						!userInfo.isThirdPartyUserWithNoRecord &&
						env.getPortfolioCfg() ? (
							<TabControl
								className={activeClassHandler(tabTypes.portfolioViewTab)}
								onClick={() => onTabChanged(tabTypes.portfolioViewTab)}
							>
								{labels.portfolioview}
							</TabControl>
						) : (
							[]
						)}
						{userInfo.isThirdPartyUser !== undefined &&
						userInfo.isThirdPartyUserWithNoRecord !== undefined &&
						!userInfo.isThirdPartyUser &&
						!userInfo.isThirdPartyUserWithNoRecord ? (
							<TabControl
								className={activeClassHandler(tabTypes.AllEngagementsTab)}
								onClick={() => onTabChanged(tabTypes.AllEngagementsTab)}
							>
								{labels.allengagements}
							</TabControl>
						) : (
							[]
						)}
						{userInfo.isThirdPartyUser !== undefined &&
						userInfo.isThirdPartyUserWithNoRecord !== undefined &&
						!userInfo.isThirdPartyUser &&
						!userInfo.isThirdPartyUserWithNoRecord ? (
							<TabControl
								className={activeClassHandler(tabTypes.FavoritesTab)}
								onClick={() => onTabChanged(tabTypes.FavoritesTab)}
							>
								{labels.favorites}
							</TabControl>
						) : (
							[]
						)}
						{isReviewEngagementAvailable ? (
							<TabControl
								className={activeClassHandler(tabTypes.ReviewengagementsTab)}
								onClick={() => onTabChanged(tabTypes.ReviewengagementsTab)}
							>
								{labels.reviewengagement}
							</TabControl>
						) : (
							[]
						)}
					</TabNavigation>
				</StyledTabBar>

				<section className="filterrow">
					{userInfo.isThirdPartyUser !== undefined &&
					userInfo.isThirdPartyUserWithNoRecord !== undefined &&
					!userInfo.isThirdPartyUser &&
					!userInfo.isThirdPartyUserWithNoRecord ? (
						// &&
						// !location.pathname.includes('/engagementsv2')
						<Dropdown
							open={showDropdownState}
							placement="bottom-end"
							handleClickOutside={setClickOutside}
							handleOnOpen={handleAdobe}
							trigger={
								<Button
									type="button"
									variant="secondary"
									onClick={handleToggle}
								>
									<Icon src={contentIcAddCircle24px} />
									{labels.addEngagement}
								</Button>
							}
						>
							{getMenuItems().map((option, index) => {
								return (
									<DropdownItem
										onClick={() => handleEngagementOptionsChange(option)}
										title={option.label}
										key={index}
									>
										{option.label}
									</DropdownItem>
								);
							})}
						</Dropdown>
					) : (
						[]
					)}
					{userInfo.isThirdPartyUser !== undefined &&
						userInfo.isThirdPartyUserWithNoRecord !== undefined &&
						!userInfo.isThirdPartyUserWithNoRecord && (
							// !location.pathname.includes('/engagementsv2') &&
							<EngagementGrouping
								location={location}
								history={history}
								resetPager={() => setSkip(1)}
							/>
						)}
				</section>
			</section>

			{isTabEngV2 && isPortfolioActive() ? (
				isLoading ? (
					<section className="portfolio-loader">
						<LoadingIndicator show fullscreen />;
					</section>
				) : (
					<PortfolioView
						fullname={
							userSettings.data.userfname + ' ' + userSettings.data.userlname
						}
						isReviewEngagementAvailable={isReviewEngagementAvailable}
						activeFilter={currentTabState}
						defaultTop={topEngagementv2}
						defaultSkip={skipEngagementv2}
					/>
				)
			) : (
				userInfo.isThirdPartyUser !== undefined &&
				userInfo.isThirdPartyUserWithNoRecord !== undefined && (
					<>
						<section className="page-filter">
							{!userInfo.isThirdPartyUserWithNoRecord && (
								<section className="search-filter">
									<MotifSearch
										id="engagements-search"
										className="engagements-search"
										value={searchText.searchText}
										onChange={(event) =>
											dispatch(searchEngagementState(event.target.value))
										}
										placeholder={labels.searchTextPlaceHolder}
										onClear={onClearSearchText}
										onSearchButtonClick={handleOnSubmit}
										onEnter={handleOnSubmit}
									/>
									{groupBy !== displayGroupings.MODULE && (
										<section className="engagements-sort">
											<Dropdown
												className="engagements-sortdropdwn"
												placement="bottom-start"
												id="engagements-sort"
												closeOnOutsideClick={true}
												trigger={
													<Button
														id="engagementssort-trigger"
														className="engsort-trigger"
														type="button"
														variant="secondary"
													>
														<Icon
															src={IconoirDataTransferBoth}
															title="options"
														/>
														<span className="engsorttrigger-label">
															{labels.engagementSortBy}
														</span>
													</Button>
												}
											>
												{engagementSortByOptions.map((option) => (
													<DropdownItem
														key={option.id}
														value={option.id}
														onClick={() => {
															onEngagementSortByChangeHandler(option.id);
														}}
													>
														<span>{option.value}</span>
														{selectedEngagementSortBy === option.id && (
															<Icon src={IconoirCheck} title="selected" />
														)}
													</DropdownItem>
												))}
											</Dropdown>
										</section>
									)}
								</section>
							)}
							<section className="pagination">
								<Pagination
									styleName="pagination"
									dropdown_position="left"
									options_per_page={pagerOptions}
									default_dropdown_value={top}
									currentPage={skip}
									TotalPages={totalPages}
									showText={labels.show}
									iconHover={svgHoverText}
									onInputChange={onPagerInputChange}
									onDropdownChange={onPagerDropdownChange}
									onFirstPageClick={onFirstPageClicked}
									onPrevPageClick={onPrevPageClicked}
									onNextPageClick={onNextPageClicked}
									onLastPageClick={onLastPageClicked}
								/>
							</section>
						</section>

						<ul>
							{!isLoading ? (
								groupBy === displayGroupings.LIST ? (
									engagementList && engagementList.allengagements ? (
										engagementList.allengagements.map((engagement) => (
											<EngagementList
												workspaceID={engagement.workspaceID}
												workspace={engagement.workspace}
												engagements={engagement.engagements}
												viewDisplayName={viewDisplayName}
												client={engagement.client}
												clientId={engagement.client.id}
												clientName={engagement.clientName}
												clientCode={engagement.clientCode}
												refreshDashboard={loadPagedDataAsync}
												archiveretryshortcutkey={archiveRetryShortcutKey}
											/>
										))
									) : null
								) : clients ? (
									<ClientList
										clients={clients}
										refreshDashboard={loadPagedDataAsync}
										archiveretryshortcutkey={archiveRetryShortcutKey}
										isReviewWorkspaces={
											currentTabState === tabTypes.ReviewengagementsTab
										}
									/>
								) : null
							) : (
								<LoadingIndicator show />
							)}
						</ul>

						{!totalRecordCount && isSearching && !isLoading && (
							<section className="empty-message">
								<section className="norecords">
									<p>{labels.nomatches}</p>
									<p className="try-message">{labels.pleasetryagain}</p>
								</section>
							</section>
						)}
						{!totalRecordCount && !isSearching && !isLoading && (
							<section className="empty-message">
								<section className="norecords">
									{currentTabState === tabTypes.FavoritesTab ? (
										<p>
											<p>{labels.nofavoriteengagementsmsg1}</p>
											<p>{labels.nofavoriteengagementsmsg2}</p>
											<p>{labels.nofavoriteengagementsmsg3}</p>
										</p>
									) : currentTabState === tabTypes.ReviewengagementsTab ? (
										isEyUser() !== undefined ? (
											<p>{labels.noreviewengagementsmessage}</p>
										) : (
											<p>{labels.noreviewengagementsmessagecontact}</p>
										)
									) : (
										((myEngagements &&
											myEngagements.allengagements &&
											myEngagements.allengagements.length == 0) ||
											!myEngagements.allengagements) && (
											<p>{labels.noengagementsforusermessage}</p>
										)
									)}
								</section>
							</section>
						)}
					</>
				)
			)}
			{isMobile && (
				<StyledAddNoteButton>
					<section className="device-toggle-icon">
						<Icon src={deviceIcDevices24px} />
					</section>
					<section className="device-toggle-main">
						<a className="device-toggle-label" href="/mobile/engagements">
							{labels.toggleView}
						</a>
					</section>
				</StyledAddNoteButton>
			)}
		</DashboardStyles>
	);
};
export default Dashboard;

const StyledAddNoteButton = styled.section`
	position: fixed;
	right: var(--px-24);
	bottom: var(--px-32);
	border-radius: var(--px-25);
	padding-left: var(--px-27);
	height: 30px;
	width: fit-content;
	// used rgb instead bec theme color not available
	background-color: rgb(19, 110, 246);
	z-index: 9999;
	display: flex;
	.device-toggle-icon {
		width: 15px;
		align-content: center;
		line-height: var(--px-2);
	}
	.device-toggle-main {
		padding-right: var(--px-27);
		width: fit-content;
		line-height: var(--px-30);
		.device-toggle-label {
			padding: 5px;
		}
	}
`;

const StyledTabBar = styled.section`
	display: inline-flex;
	width: 65%;
	.view-switcher {
		padding-left: var(--px-53-5);
		border: none;
		.motif-tab-button {
			height: var(--px-45);
			margin-right: var(--px-15);
			font-size: var(--font-16);
		}
	}
`;

const StyledNotificationToast = styled.section`
	width: calc(100vw - var(--px-85)) !important;
	top: var(--px-15) !important;
	left: var(--px-40) !important;
	margin: 0 auto !important;
	padding: 0 !important;
	z-index: 1000 !important;
	max-width: 2048px;
	position: fixed;
	@media only screen and (min-width: 2048px) {
		width: calc(100vw - var(--px-170)) !important;
		left: var(--px-82) !important;
	}
	.motif-toast {
		&.motif-toast-error {
			.motif-toast-icon-container svg {
				fill: var(--red-600) !important;
				width: var(--px-18);
				height: var(--px-18);
				margin-top: -var(--px-3);
			}
		}
	}
`;
